import { Component } from '@angular/core';
import { FormsModule, UntypedFormControl } from '@angular/forms';

import { CommonModule } from '@angular/common';
import { KENDO_BUTTONS } from '@progress/kendo-angular-buttons';
import { KENDO_DATEPICKER } from '@progress/kendo-angular-dateinputs';
import { KENDO_DIALOGS } from '@progress/kendo-angular-dialog';
import { KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns';
import { ColumnComponent, ExcelExportComponent } from '@progress/kendo-angular-excel-export';
import { KENDO_GRID, KENDO_GRID_EXCEL_EXPORT, KENDO_GRID_PDF_EXPORT } from '@progress/kendo-angular-grid';
import { KENDO_INDICATORS } from '@progress/kendo-angular-indicators';
import { KENDO_INPUTS } from '@progress/kendo-angular-inputs';
import { ToastrService } from 'ngx-toastr';
import { AlertService } from '../../@theme/services/alert.service';

@Component({
  selector: 'gd--accessreports',
  templateUrl: './deletedblotter.component.html',
  styleUrls: ['./deletedblotter.component.scss'],
  imports: [
    CommonModule,
    KENDO_INPUTS,
    KENDO_DATEPICKER,
    KENDO_DROPDOWNS,
    KENDO_GRID,
    KENDO_INPUTS,
    KENDO_GRID_PDF_EXPORT,
    KENDO_GRID_EXCEL_EXPORT,
    KENDO_INDICATORS,
    KENDO_DIALOGS,
    KENDO_BUTTONS,
    FormsModule,
    ExcelExportComponent,
    ColumnComponent,
/*     CellTemplateDirective, */
/*     DatePipe, */
  ]
})
export class DeletedBlotterReportsComponent {
  startdate = new UntypedFormControl(new Date())
  enddate = new UntypedFormControl(new Date())
  gridExcelexportDeleted: any[] = []
  ngModelDate = new Date(new Date().setDate(new Date().getDate() - 30))
  ngModelendDate = new Date()
  selectedItem = '1'
  public aggregates: any[] = []

  constructor(
    private ur: AlertService,
    private toastrService: ToastrService,
  ) { }
  getAccessreports(component) {
    const Param = { Startdate: this.ngModelDate, Enddate: this.ngModelendDate }
    this.ur.getDeletedBlottersReports(Param).subscribe((r) => {
      this.gridExcelexportDeleted = r
      setTimeout(() => this.returndata(component), 3000)
    })
  }
  getexportAccessreports(component) {
    const Param = { Startdate: this.ngModelDate, Enddate: this.ngModelendDate }
    this.ur.getDeletedBlottersReports(Param).subscribe((r) => {
      this.gridExcelexportDeleted = r
      setTimeout(() => this.returndata(component), 3000)
    })
  }
  returndata(component) {
    const options = component.workbookOptions()
    const rows = options.sheets[0].rows
    let altIdx = 0
    rows.forEach((row) => {
      if (row.type == 'data') {
        if (altIdx % 2 !== 0) {
          row.cells.forEach((cell) => {
            cell.background = '#aabbcc'
          })
        }
        altIdx++
      }
    })
    this.showToast('success', 'Please wait, your Excel is being downloaded.')
    component.save(options)
  }
  getAccessexportreports(component) {
    const Param = { Startdate: this.ngModelDate, Enddate: this.ngModelendDate }
    this.ur.getDeletedExportBlottersReports(Param).subscribe((r) => {
      console.log('test=' + JSON.stringify(r))
      this.gridExcelexportDeleted = r
      setTimeout(() => this.returndata(component), 3000)
    })
  }
  ExportToExcel(component) {
    this.getAccessexportreports(component)
    this.showToast('success', 'Please wait, your Excel is being downloaded.')
    
  }
  showToast(status: 'success' | 'error' | 'info' | 'warning', message: string) {
    switch (status) {
      case 'success':
        this.toastrService.success(message, 'Success');
        break;
      case 'error':
        this.toastrService.error(message, 'Error');
        break;
      case 'info':
        this.toastrService.info(message, 'Info');
        break;
      case 'warning':
        this.toastrService.warning(message, 'Warning');
        break;
      default:
        this.toastrService.show(message);
        break;
    }
  }
}
